import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class MasterDataService extends BaseService {
  private readonly _activeJobTypeVersionUrl =
    '/maintenance/api/master-data/get-active-job-type-version';

  private activeJobTypeVersion$: Observable<string>;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getActiveJobTypeVersion() {
    if (!this.activeJobTypeVersion$) {
      this.activeJobTypeVersion$ = this.get<string>(
        this._activeJobTypeVersionUrl
      ).pipe(shareReplay(1));
    }
    return this.activeJobTypeVersion$;
  }
}
